import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { Shell } from 'App/Shell'
import AuthedShell from 'App/Shell/AuthedShell'

const ShellContainer = ({ profile, children, ...rest }) => profile
  ? <AuthedShell profile={profile}>{children}</AuthedShell>
  : <Shell profile={profile}>{children}</Shell>

ShellContainer.propTypes = {
  children: PropTypes.node,
  profile: PropTypes.object
}

const mapStateToProps = ({ oidc, catalog }) => {
  const { user } = oidc
  const { profile } = user || {}
  return { profile }
}

export default connect(mapStateToProps)(ShellContainer)



// WEBPACK FOOTER //
// ./src/App/Shell/ShellContainer.js